import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-confirmacion-cuenta');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheConfirmacionCuenta = (): void => {
  cache.valor = null;
};

export const confirmacionCuentaResolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'confirmacion-cuenta',
    uidTipo: 'pagina',
    slug: 'paginaconfirmacioncuenta',
  });
